import * as angular from "angular";
import {IController, IIntervalService} from "angular";
import {WidgetModel} from "../../models/widget.model";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import * as moment from "moment";
import {DataSourceMetricColorEnum} from "../../enums/data-source-metric-color.enum";
import {WidgetTypeEnum} from "../../enums/widget-type.enum";
import {DashboardsServiceService} from "../../services/dashboards-service.service";

export class WidgetContainerComponent implements IController {

  widget: WidgetModel;
  dateRange: any;
  onDeleteWidget: Function;

  public data: any;
  public refreshRateIntervalRef: any;
  public lastRefreshDate: number;
  public dataSourceMetricColorEnum: typeof DataSourceMetricColorEnum = DataSourceMetricColorEnum;
  public isRefreshButtonDisabled = false;
  public widgetTypeEnum: typeof WidgetTypeEnum = WidgetTypeEnum;
  public isLoadingData: boolean;
  public widgetPieChartSegmentsMap: any;

  constructor(private dashboardsServiceService: DashboardsServiceService, private $interval: IIntervalService) {
  }

  $onInit() {
    this.getData();
    if (!!this.widget.refreshInterval) {
      this.refreshRateIntervalRef = this.$interval(() => {
        this.getData();
      }, (this.widget.refreshInterval * 60 * 1000));
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.dateRange && !changes.dateRange.isFirstChange()) {
      this.getData();
    }
  }

  $onDestroy() {
    if (this.refreshRateIntervalRef) {
      this.$interval.cancel(this.refreshRateIntervalRef);
    }
  }

  refreshData() {
    this.getData();
    this.isRefreshButtonDisabled = true;
  }

  private getData() {
    this.isLoadingData = true;
    const queryParams = {
      ...this.widget.filters,
      // beforeTimeWindow: this.widget.filters.timeToDeliver === 'beforeTimeWindow' || undefined,
      // afterTimeWindow: this.widget.filters.timeToDeliver === 'afterTimeWindow' || undefined,
      from: this.dateRange.dateStart,
      to: this.dateRange.dateEnd
    }
    this.dashboardsServiceService.getDashboardWidgetData(this.widget.datasource, queryParams).then((data) => {
      this.data = data;
      this.lastRefreshDate = moment().valueOf();
      this.isRefreshButtonDisabled = false;
      this.isLoadingData = false;

      if (this.widget.widgetType === this.widgetTypeEnum.PieChartWidget) {
        this.initPieChartWidgetSegments();
      }
    })
  }

  private initPieChartWidgetSegments() {
    this.widgetPieChartSegmentsMap = {};
    for (const [metricKey, metricValues] of Object.entries(this.widget.metrics)) {
      this.widgetPieChartSegmentsMap[metricKey] = {};
      metricValues.forEach(mv => {

        this.widgetPieChartSegmentsMap[metricKey][mv.metricValue] = {};
        this.widgetPieChartSegmentsMap[metricKey][mv.metricValue].innerTextConfiguration = {
          color: this.dataSourceMetricColorEnum[this.widget.datasource][metricKey][mv.metricValue],
          text: this.data[mv.metricValue] + '/' + this.data.total
        }

        this.widgetPieChartSegmentsMap[metricKey][mv.metricValue].segments = [
          {
            value: this.data[mv.metricValue],
            color: this.dataSourceMetricColorEnum[this.widget.datasource][metricKey][mv.metricValue]
          },
          {
            value: this.data.total - this.data[mv.metricValue],
            color: this.addAlphaToRgb(this.dataSourceMetricColorEnum[this.widget.datasource][metricKey][mv.metricValue], 0.3)
          }
        ]
      })
    }
  }

  private addAlphaToRgb(rgb, alpha) {
    const [r, g, b] = rgb.match(/\d+/g).map(Number);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('widgetContainer', {
    bindings: {
      widget: '<',
      dateRange: '<',
      onDeleteWidget: '&'
    },
    template: require('./widget-container.html').default,
    controller: WidgetContainerComponent
  });
